module.exports = __webpack_public_path__ + "static/media/21.2159f4b1.jpg";